import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import LandingPage from './components/LandingPage';
import Login from './components/Login';
import RegisterCandidate from './components/RegisterCandidate';
import RegisterEmployer from './components/RegisterEmployer';
import EmailVerification from './components/EmailVerification';
import Dashboard from './components/Dashboard';
import EmployerRequestForm from './components/EmployerRequestForm';
import ForcePasswordChange from './components/ForcePasswordChange';
import ResetPassword from './components/ResetPassword';
import ForgotPassword from './components/ForgotPassword';
import { AuthProvider, useAuth } from './context/AuthContext';
import { SystemStatusProvider } from './context/SystemStatusContext';
import SystemDownOverlay from './components/SystemDownOverlay';

// Wrapper component to access auth context
function PasswordChangeWrapper() {
  const { user, refreshProfile } = useAuth();
  
  const handlePasswordChanged = async () => {
    // Refresh user profile to update mustChangePassword flag
    await refreshProfile();
  };
  
  return <ForcePasswordChange user={user} onPasswordChanged={handlePasswordChanged} />;
}

function App() {
  useEffect(() => {
    document.title = 'Liaizn';
  }, []);

  return (
    <AuthProvider>
      <SystemStatusProvider>
        <Router>
          <div className="min-h-screen bg-surface">
          <Toaster 
            position="top-right" 
            reverseOrder={false}
            gutter={8}
            toastOptions={{
              duration: 4000,
              style: {
                background: '#0f172a',
                color: '#fff',
                padding: '14px 16px',
                borderRadius: '12px',
                fontSize: '14px',
                maxWidth: '500px',
                boxShadow: '0 8px 24px rgba(15, 23, 42, 0.18)',
              },
              success: {
                duration: 3000,
                iconTheme: {
                  primary: '#ce4f53',
                  secondary: '#fff',
                },
                style: {
                  background: '#ce4f53',
                  color: '#fff',
                }
              },
              error: {
                duration: 5000,
                iconTheme: {
                  primary: '#fff',
                  secondary: '#8f3236',
                },
                style: {
                  background: '#8f3236',
                  color: '#fff',
                }
              },
            }}
          />
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Navigate to="/register/candidate" replace />} />
            <Route path="/register/candidate" element={<RegisterCandidate />} />
            <Route path="/register/employer" element={<RegisterEmployer />} />
            <Route path="/verify-email" element={<EmailVerification />} />
            <Route path="/change-password" element={<PasswordChangeWrapper />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/dashboard/*" element={<Dashboard />} />
            <Route path="/employer-request-form/:requestId" element={<EmployerRequestForm />} />
          </Routes>
          <SystemDownOverlay />
          </div>
        </Router>
      </SystemStatusProvider>
    </AuthProvider>
  );
}

export default App;
